import { useQuery } from '@tanstack/react-query';
import { getBroadcastMessages } from '@/lib/coloc-api/admin';
import { BroadcastMessageStatus } from '../types';

type UseGetBroadcastMessagesProps = {
  status?: BroadcastMessageStatus;
  colocation_ids?: string[];
};

export const useGetBroadcastMessages = ({
  status,
  colocation_ids,
}: UseGetBroadcastMessagesProps) => {
  const query = useQuery({
    queryKey: ['broadcast-messages', status, colocation_ids],
    queryFn: async () => {
      const response = await getBroadcastMessages(status, colocation_ids);
      return response.data.data;
    },
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
};
